import React, {Component, Fragment} from 'react';
import {observer} from 'mobx-react';
import {FormattedMessage, injectIntl} from 'react-intl';
import './styles.scss';
import Popover from "@material-ui/core/Popover";
import {withTooltip} from "../../components/toolTip/withTooltip";
import SvgIcon from "@material-ui/core/SvgIcon";
import List from "@material-ui/core/List";
import ListItemText from "@material-ui/core/ListItemText";
import ListItem from "@material-ui/core/ListItem";
import IconButton from "@material-ui/core/IconButton";
import chevron from "../../assets/images/chevron";
import Switch from "../../components/Switch";
import ListItemSecondaryAction from "@material-ui/core/ListItemSecondaryAction";
import {ReactComponent as SelectedIcon} from '../../assets/images/video/selected-device.svg';

@withTooltip
@injectIntl
@observer
class DeviceSelect extends Component {

    componentDidMount() {
    }

    onClickDevice = (deviceId) => {
        const {onDeviceSet, onDismissTooltip} = this.props;
        onDeviceSet(deviceId);
        onDismissTooltip();
    }


    render() {
        const {titleKey, deviceList, icon, iconMuted, onClickMute, muted, anchorEl, onToggleTooltip, isTooltipOpen, onDismissTooltip,
            compact = false, withMirror = false, toggleLocalMirroring, localMirroringActive, intl: {formatMessage: translate}} = this.props;
        return (
            <Fragment>
                <IconButton classes={{root: `device-selector-btn ${muted ? 'muted' : ''}`}} onClick={onClickMute}>
                    <SvgIcon classes={{root: 'device-selector-icon'}} viewBox="0 0 24 24">{muted ? iconMuted : icon}</SvgIcon>
                </IconButton>
                {!compact && <IconButton classes={{root: `device-selector-btn-2 ${muted ? 'muted' : ''}`}} onClick={onToggleTooltip}>
                    <SvgIcon classes={{root: `device-selector-icon-2 ${isTooltipOpen ? 'open' : ''}`}}>{chevron}</SvgIcon>
                </IconButton>}

                <Popover
                    className="device-selector"
                    classes={{paper: 'device-selector-popover-area'}}
                    anchorEl={anchorEl}
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'left',
                    }}
                    transformOrigin={{
                        vertical: 'bottom',
                        horizontal: 'left',
                    }}
                    open={isTooltipOpen}
                    onClose={onDismissTooltip}>
                    <div className="device-selector-area">
                        <b><FormattedMessage id={titleKey}/></b>
                        <List component="nav" aria-label="devices">
                            {deviceList.map(device => {
                                return (
                                    <ListItem disableGutters key={device.value} button onClick={() => this.onClickDevice(device.value)}>
                                        <ListItemText primary={device.label} classes={{primary: 'primary'}}/>
                                        {device.selected && <ListItemSecondaryAction>
                                            <SelectedIcon/>
                                        </ListItemSecondaryAction>}
                                    </ListItem>
                                );
                            })}
                        </List>
                        {withMirror && <>
                            <div className='mirror-divider'/>
                            <div className='mirror-input'>
                                <FormattedMessage id={'video.chat.select.video.mirror'}/>
                                <Switch
                                    containerClass="mirror-switch"
                                    classes={{
                                        switchBase: 'mirror-switch-base',
                                        bar: 'mirror-switch-bar',
                                        icon: 'mirror-switch-icon',
                                        checked: 'mirror-switch-checked'
                                    }}
                                    isActive={localMirroringActive}
                                    onClick={toggleLocalMirroring}
                                    disabled={false}
                                />
                            </div>
                        </>}
                    </div>
                </Popover>
            </Fragment>


        );
    }
}

export default DeviceSelect;
